export const SelectChargeTypeOpt = [
  { id: 2, name: 'Per Unit' },
  { id: 1, name: 'Per Kg' },
]
export const selectChargeOpt = [
  { id: 1, name: 'Pickup Cartage' },
  { id: 2, name: 'Drop Off Cartage' },
]
export const headers = [
  { header: 'SN', field: 'SN', width: '20px', align: 'left', showfilter: false },
  { header: 'Company Name', field: 'CompanyName', width: '200px', showfilter: true },
  { header: 'Branch Name', field: 'BranchName', width: '190px', showfilter: true },
  { header: 'City Name', field: 'CityName', width: '107px', showfilter: true },
  { header: 'State Name', field: 'StateName', width: '100px', showfilter: true },
  { header: 'Cartage Type', field: 'ChargeType', width: '90px', showfilter: true },
  { header: 'Range Min.', field: 'RangeMin', width: '84px', align: 'right', showfilter: true },
  { header: 'Range Max.', field: 'RangeMax', width: '106px', align: 'right', showfilter: true },
  { header: 'Cartage', field: 'Rate', width: '84px', align: 'right', showfilter: true },
  { header: 'Modified By', field: 'ModifiedByUser', width: '120px', showfilter: true },
  { header: 'Modified Date & Time', field: 'ModifiedDateTime', width: '140px', showfilter: false },
  { header: 'Status', field: 'Status', width: '60px', showfilter: false, align: 'center' },
]
